module.exports = __webpack_public_path__ + "assets/img/img-map-kagoshima-sp.0ab54397.svg";